<template>
  <a-modal v-bind:open="this.showModal"
           width="800px"
           :closable="true"
           :mask-closable="true"
           :footer="null"
           :mask-style="{backdropFilter: 'blur(2px)'}"
           :keyboard="false"
           @cancel="uiHandler.closeModal"
  >
    <template #title>
      <a-row style="width: 720px" align="middle">
        <a-col :span="20"><p style="font-weight: bold; margin-bottom: 0px;">{{modalTitle}}</p></a-col>
        <a-col :span="4">
          <a-button 
            type="primary"
            @click="uiHandler.handleModal.addCard.show">신용카드 등록
          </a-button>
        </a-col>
      </a-row>
    </template>
    <div style="padding: 10px 10px 20px 10px">
      <div class="table-spinner-container" v-if="dataLoading">
          <div class="spinner" />
      </div>
      <a-table class="ant-table-striped"
               bordered
               size="small"
               :columns="card.columns"
               :data-source="processedDataSource"
               :pagination="false"
               v-if="processedDataSource.length > 0"
      >
      </a-table>
      <div class="no-result-container" v-else>
          <i class="fa-solid fa-exclamation-triangle" />
          <span>결제카드 등록을 요청해 주세요.</span>
      </div>
    </div>
  </a-modal>

  <add-card-modal
      :show-modal="modal.addCard.show"
      @close-modal="uiHandler.handleModal.addCard.close"
  />
</template>
<script>
import {styles} from "@/views/ContractManagement/styles";
import subscriptionApi from "@/views/SubscriptionManagement/plasmapp/api";
import {logging, oneBtnDialog} from "@/utils/utils";
import AddCardModal from './AddCardModal.vue';
import {SubscriptionCardStatusEnum} from "@/views/SubscriptionManagement/plasmapp/subscriptionCardStatusEnum";

const readOnly = {
  event: {
    CloseModal: "CloseModal",
    Reload: "Reload",
  },
}

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false
    },
    dataSource: {
      type: Array,
      required: true,
      default: () => []
    },
    clientName: {
      type: String,
      required: false,
      default: "",
    },
    productName: {
      type: String,
      required: false,
      default: "",
    },
  },
  components: {
    AddCardModal,
  },
  computed: {
    processedDataSource() {
      return this.dataSource.map((d, idx) => {
        return {...d, no: idx + 1}
      })
    },
    modalTitle() {
      return `병원 카드 관리 ${this.clientName ? "-" + this.clientName : ''} ${this.productName ? "-" + this.productName : ''}`
    },
  },
  data() {
    return {
      uiHandler: this.ui(),
      apiHandler: this.api(),
      dataLoading: false,
      modal: {
        addCard: {
          show: false
        },
      },
      card: {
        columns: [
          {key: 'no', title: '회차', dataIndex: 'no', align: 'center', width: 40},
          {key: 'cardCompany', title: '카드회사', dataIndex: 'cardCompany', align: 'center'},
          {key: 'validationDate', title: '유효기간', dataIndex: 'validationDate', align: 'center'},
          {
            key: 'status', title: '상태', dataIndex: 'status', align: 'center',
            customRender: ({text, record}) => {
              let tagColor;
              if (text === SubscriptionCardStatusEnum.USE) {
                tagColor = styles.tags.green
              } else if (text === SubscriptionCardStatusEnum.REGISTER) {
                tagColor = styles.tags.blue
              } else if (text === '사용안함') {
                tagColor = styles.tags.gray // deprecated
              } else if (text === SubscriptionCardStatusEnum.CANNOT_USE) {
                tagColor = styles.tags.red
              } else if (text === '등록필요') {
                tagColor = styles.tags.red  // deprecated
              }
              return (
                  <a-row style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <a-tag style={{...styles.tags.statusTag, ...tagColor}}>{text}</a-tag>
                  </a-row>
              )
            }
          },
          {
            key: 'check', title: '자동결제 빌링키 발급', dataIndex: 'check', align: 'center',
            customRender: ({text, record}) => {
              logging().exceptProd("record====>", record)
              if (record.status === SubscriptionCardStatusEnum.USE) {
                return (
                    <a-row style={{justify: "flex", justifyContent: 'center', alignItems: 'center'}}>
                      <a-button style={{height: '10px'}}
                                // disabled={record?.billingKey}
                                onClick={async e => {
                                  await this.uiHandler.authorizationCard(record.cardNo).then(() => {
                                    this.uiHandler.reload()
                                  })
                                }}>재발급하기
                      </a-button>
                    </a-row>
                )
              } if (record.status === SubscriptionCardStatusEnum.REGISTER) {
                return (
                    <a-row style={{justify: "flex", justifyContent: 'center', alignItems: 'center'}}>
                      <a-button style={{height: '10px'}}
                          // disabled={record?.billingKey}
                                onClick={async e => {
                                  await this.uiHandler.authorizationCard(record.cardNo).then(() => {
                                    this.uiHandler.reload()
                                  })
                                }}>발급하기
                      </a-button>
                    </a-row>
                )
              } else {
                return "-"
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    ui() {
      return {
        authorizationCard: async (cardNo) => {
          this.dataLoading = true
          await this.apiHandler.authorizationCardBySubscription({
            subscriptionId: sessionStorage.getItem("selectedSubscriptionId"),
            cardNo: cardNo
          }, async (response) => {
            await oneBtnDialog('안내', response.data)
          }, async (error) => {
            await oneBtnDialog('카드 검증 실패', error.response.data.message)
          }).finally(() => this.dataLoading = false)
        },
        closeModal: () => {
          this.$emit(readOnly.event.CloseModal, {
            ModalStatus: false
          });
        },
        reload: () => {
          this.$emit(readOnly.event.Reload, {
          });
        },
        handleModal: {
          addCard: {
            show: async () => {
              this.modal.addCard.show = true
            },
            close: async () => {
              this.uiHandler.reload()
              this.modal.addCard.show = false
            }
          }
        }
      }
    },
    api() {
      return subscriptionApi(this.$apiInstance, this.$store)
    }
  }
}
</script>
<style scoped></style>